export const withQuantityOfDecimals = (amount: number, numberOfDecimals: number) => {
  return Number(amount.toFixed(numberOfDecimals));
};
